module.exports = __webpack_public_path__ + "assets/img/avatar_icon.dcdcf23.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/icons/avatar_icon.png
// module id = TdxR
// module chunks = 50